export default __webpack_public_path__ + "static/media/bg_login.c5ce0180.svg";